import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { CircularProgress } from '@mui/material';
import Button from '@mui/material/Button';
import MobileStepper from '@mui/material/MobileStepper';
import moment from 'moment';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { obtenerDataBytesImagen } from '../../../actions/ImagenActionBytes';
import { adaptProgramaArray } from '../../../adapters/adapterProgramaPrePaciente';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import { DateInput } from '../../../components/dateInput/DateInput';
import DocumentViewer from '../../../components/DocumentViewer';
import { FileInput } from '../../../components/fileInput/FileInput';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { TextInput } from '../../../components/textInput/TextInput';
import { CREATE_PACIENTE_PROBABLE } from '../../../data/graphQL/mutations/PacienteProbable/createPacienteProbable';
import { UPDATE_PACIENTE_PROBABLE } from '../../../data/graphQL/mutations/PacienteProbable/updatePacienteProbable';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_ALL_ESTADOS } from '../../../data/graphQL/queries/PacienteProbable/getAllEstados';
import { GET_ALL_TIPO_DOCUMENTO } from '../../../data/graphQL/queries/PacienteProbable/getAllTipoDocumento';
import { GET_INSTITUCIONES_BY_DELEGACION_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getInstitucionesByDelegacionAndUsuario';
import { GET_PACIENTE_PROBABLE_BY_ID } from '../../../data/graphQL/queries/PacienteProbable/getPacienteProbableById';
import { GET_PROGRAMA_PRE_PACIENTE } from '../../../data/graphQL/queries/PrePaciente/queries';
import { GET_ROLES_BY_USER } from "../../../data/graphQL/queries/Reclamos/getRolesByUserId";
import { useGetBreakpoints } from '../../../responsiveTools/breakpoints';
import { DesktopOrTabletContainer, MobileContainer } from '../../../responsiveTools/ResponsiveContainers';
import './pacienteProbableCreationContent.scss';

const ESTADO_PENDIENTE = 1;
const ESTADO_A_EXTERNAR = 2;
const ESTADO_OBITO = 3;
const ESTADO_RECUPERADO = 4;

// Roles
const ROL_RESPONSABLE_US = 53;
const ROL_UNIDAD_SOPORTE = 54;
const ROL_VENTAS = 55;

const initialFormModel = {
  idPrePaciente: 0,
  idDelegacion: null,
  codInstitucion: null,
  nombre: '',
  apellido: '',
  sexo: null,
  edad: null,
  fechaNacimiento: null,
  idTipoDocumento: null,
  nroDocumento: '',
  telPaciente: '',
  telFamiliar: '',
  nombreFamiliar: '',
  observacion: '',
  idEstado: ESTADO_PENDIENTE,
  referente: '',
  financiador: '',
  fechaAltaProbable: null,
  idTipoModulo: null,
  fechaAlta: null
};

export const PacienteProbableCreationContent = ({
  setChildrenAction
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const { isMobile } = useGetBreakpoints();

  const location = useLocation();
  const editPacienteData = location?.state;
  const isPreviewMode = editPacienteData?.previewMode;

  const [selectedFileName, setSelectedFileName] = useState();
  const [openDlg, setOpenDlg] = useState(false);

  const [esUnidadSoporte, setEsUnidadSoporte] = useState(false);
  const [esVentas, setEsVentas] = useState(false);

  const navigate = useNavigate();

  const [getUserRoles, { data: dataUserRoles, loading: userRolesLoading }] = useLazyQuery(GET_ROLES_BY_USER, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataUserRoles) return;
    setEsUnidadSoporte(dataUserRoles.rolesByUserId.filter((r) => r.id == ROL_UNIDAD_SOPORTE).length > 0);
    setEsVentas(dataUserRoles.rolesByUserId.filter((r) => r.id == ROL_VENTAS).length > 0);
  }, [dataUserRoles]);

  useEffect(() => {
    if (!userRolesLoading)
      getUserRoles();
  }, []);

  const [createPacienteProbable, { loading: creationLoading }] = useMutation(CREATE_PACIENTE_PROBABLE, {
    onCompleted: (datosDes) => {
      if (datosDes.createPrePaciente.success) {
        toast.success("Pre Paciente creado correctamente!");
        setTimeout(() => {
          navigate((esVentas) ? '/pacienteProbableCOM' : '/pacienteProbable');
        }, 2000);
      } else {
        toast.error(datosDes.createPrePaciente.error);
        return false;
      }
    },
    onError: (datosDes) => {
      toast.error("Error al crear el Pre Paciente");
      return false;
    }
  });

  const [updatePacienteProbable, { loading: editionLoading }] = useMutation(UPDATE_PACIENTE_PROBABLE, {
    onCompleted: (datosDes) => {
      if (datosDes.updatePrePaciente.success) {
        toast.success("Pre Paciente actualizado correctamente!");
        setTimeout(() => {
          navigate((esVentas) ? '/pacienteProbableCOM' : '/pacienteProbable');
        }, 2000);
      } else {
        toast.error(datosDes.updatePrePaciente.error);
        return false;
      }
    },
    onError: (datosDes) => {
      toast.error("Error al actualizar el Pre Paciente");
      return false;
    }
  });
  const {
    delegaciones,
    hayInstituciones,
    instituciones,
    estados,
    formData,
    setFormData,
    pacienteLoading,
    tipoDocumentoOptions,
    programas
  } = useGetPacienteProbableFormData(editPacienteData);

  const handleChange = (e) => {
    const { value, name } = e.target;
    if (name !== 'fechaNacimiento' && name !== 'fechaAltaProbable') {
      setFormData({
        ...formData,
        [name]: value
      });
    } else if (name === 'fechaNacimiento') {
      setFormData({
        ...formData,
        [name]: value !== 'Fecha inválida' ? value : null,
        edad: moment().diff(moment(value), 'years')
      });
    } else if (name === 'fechaAltaProbable') {
      setFormData({
        ...formData,
        [name]: value !== 'Fecha inválida' ? value : null
      });
    }
  };

  const sendData = () => {
    const { ...usefulProps } = formData;
    const parsedAge = parseInt(formData?.edad, 10);

    if (editPacienteData?.idPaciente) {
      updatePacienteProbable({
        variables: {
          ...usefulProps,
          edad: parsedAge
        }
      });

    } else {
      createPacienteProbable({
        variables: {
          ...usefulProps,
          edad: parsedAge
        }
      });
    }
  };

  const isValid = () => {
    if (formData.idDelegacion <= 0) {
      toast.error("La Delegación es obligatoria.");
      return false;
    }

    if (hayInstituciones && esUnidadSoporte && (formData.codInstitucion == '' || formData.codInstitucion == null)) {
      toast.error("La Institución es obligatoria.");
      return false;
    }

    if (formData.nombre == '') {
      toast.error("El Nombre es obligatorio.");
      return false;
    }

    if (formData.apellido == '') {
      toast.error("El Apellido es obligatorio.");
      return false;
    }

    // si ingresó número de documento máxima longitud 10
    if (formData.nroDocumento != '' && formData.nroDocumento.length > 10) {
      toast.error("El número de documento debe tener una longitud máxima de 10 caracteres.");
      return false;
    }

    // formato teléfonos
    const phoneRegex = /^\+54(9\d{10}|\d{10,11})$/;
    if (formData.telPaciente != null && formData.telPaciente != "") {
      if (!phoneRegex.test(formData.telPaciente)) {
        toast.error("Ingresá en Teléfono del Paciente el número completo con código de país. Ej: +541123456789");
        return false;
      }
    }

    if (formData.telFamiliar != null && formData.telFamiliar != "") {
      if (!phoneRegex.test(formData.telFamiliar)) {
        toast.error("Ingresá en Teléfono del Familiar el número completo con código de país. Ej: +541123456789");
        return false;
      }
    }

    // Fecha de alta probable debe ser igual o posterior a la fecha de alta o a la fecha de hoy
    if (formData.fechaAltaProbable != "") {
      let fechaLimite = moment().startOf('day');
      if (formData.fechaAlta != null && moment(formData.fechaAlta).startOf('day') < fechaLimite) {
        fechaLimite = moment(formData.fechaAlta).startOf('day');
      }
      if (moment(formData.fechaAltaProbable).startOf('day') < fechaLimite) {
        toast.error("La Fecha de alta probable no puede ser anterior a " + fechaLimite.format("DD/MM/YYYY") + ".");
        return false;
      }
    }

    // si el estado es A EXTERNAR debe completar el teléfono del paciente o el teléfono del familiar del paciente
    if (formData.idEstado == ESTADO_A_EXTERNAR && formData.telPaciente == "" && formData.telFamiliar == "") {
      toast.error("Para el estado A EXTERNAR debe completar el Teléfono del Paciente o el Teléfono del Familiar.");
      return false;
    }
    return true;
  };

  const handleSubmitForm = () => {
    if (isValid())
      sendData();
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {
    setChildrenAction(() =>
      <div style={{ display: 'flex' }}>
        <CustomButton
          disabled={creationLoading || editionLoading || pacienteLoading}
          onClick={() => navigate(-1)}
          style={{ marginRight: 10 }}
          variant={'outlined'}>
          Cancelar
        </CustomButton>
        <CustomButton
          disabled={!validateSteps(formData?.idEstado === ESTADO_A_EXTERNAR) || isPreviewMode}
          isLoading={creationLoading || editionLoading || pacienteLoading}
          onClick={() => handleSubmitForm()}
          variant={'contained'}>
          Guardar
        </CustomButton>
      </div>
    );
  }, [formData, creationLoading, editionLoading, hayInstituciones]);

  const handlePreviewFile = () => {
    if (formData?.prescripcionPacienteInput != null && formData?.prescripcionPacienteInput.imagenPerfil != null)
      setOpenDlg(true);
  };

  const firstStepFieldsAreValid = () => {
    // si el rol es Unidad de Soporte es obligatorio que seleccione institución     
    if (hayInstituciones && esUnidadSoporte && (formData?.codInstitucion == '' || formData?.codInstitucion == null))
      return false;
    return (
      typeof formData?.idDelegacion === 'number' && formData?.idDelegacion > 0 &&
      formData?.apellido != "" && formData?.nombre != "");

  };

  const secondStepFieldsAreValid = () => {
    // tipo de documento y número de documento son opcionales pero si ingresó alguno de los dos
    // debe ingresar el otro para no perder consistencia
    if ((formData?.idTipoDocumento === 1 || formData?.idTipoDocumento === 2) && formData?.nroDocumento == '')
      return false;
    if (formData?.nroDocumento != '' && formData?.idTipoDocumento < 1)
      return false;
    return true;
  };

  const thirdStepFieldsAreValid = () => {
    return true;
  };

  const fourthStepFieldsAreValid = () => {
    return true;
  };

  const fifthStepFieldsAreValid = () => {
    return Boolean(formData?.idEstado);
  };

  const validateSteps = (allSteps) => {
    if (allSteps || !isMobile) {
      return (
        firstStepFieldsAreValid() &&
        secondStepFieldsAreValid() &&
        thirdStepFieldsAreValid() &&
        fourthStepFieldsAreValid() &&
        fifthStepFieldsAreValid());

    } else {
      switch (activeStep) {
        case 0:
          return firstStepFieldsAreValid();
        case 1:
          return secondStepFieldsAreValid();
        case 2:
          return thirdStepFieldsAreValid();
        case 3:
          return fourthStepFieldsAreValid();
        case 4:
          return fifthStepFieldsAreValid();
      }
    }
  };

  return (
    <div className="paciente-probable-creation">
      {pacienteLoading &&
        <div style={{
          display: 'absolute',
          justifyContent: 'center',
          alignItems: 'center',
          height: 350
        }}>
          <CircularProgress />
        </div>
      }
      {!pacienteLoading &&
        <DesktopOrTabletContainer>
          <Grid
            container
            columns={2}
            spacing={2.5}>
            <FirstStepFields
              handleChange={handleChange}
              delegaciones={delegaciones}
              hayInstituciones={hayInstituciones}
              instituciones={instituciones}
              formData={formData}
              esVentas={esVentas}
              isPreviewMode={isPreviewMode} />

            <SecondStepFields
              handleChange={handleChange}
              formData={formData}
              isPreviewMode={isPreviewMode}
              tipoDocumentoOptions={tipoDocumentoOptions} />

            <ThirdStepFields
              handleChange={handleChange}
              formData={formData}
              isPreviewMode={isPreviewMode} />

            <FourthStepFields
              handleChange={handleChange}
              formData={formData}
              selectedFileName={selectedFileName}
              setSelectedFileName={setSelectedFileName}
              isPreviewMode={isPreviewMode}
              programas={programas}
              openDlg={openDlg}
              setOpenDlg={setOpenDlg}
              handlePreviewFile={handlePreviewFile} />

            <FifthStepFields
              handleChange={handleChange}
              formData={formData}
              estados={estados}
              isPreviewMode={isPreviewMode} />

          </Grid>
        </DesktopOrTabletContainer>
      }
      {!pacienteLoading &&
        <MobileContainer>
          <div className='paciente-probable-mobile'>
            {activeStep === 0 &&
              <div>
                <FirstStepFields
                  delegaciones={delegaciones}
                  hayInstituciones={hayInstituciones}
                  instituciones={instituciones}
                  isMobile
                  handleChange={handleChange}
                  formData={formData}
                  esVentas={esVentas}
                  isPreviewMode={isPreviewMode} />

              </div>
            }
            {activeStep === 1 &&
              <div>
                <SecondStepFields
                  handleChange={handleChange}
                  isMobile
                  formData={formData}
                  isPreviewMode={isPreviewMode}
                  tipoDocumentoOptions={tipoDocumentoOptions} />

              </div>
            }
            {activeStep === 2 &&
              <div>
                <ThirdStepFields
                  isMobile
                  handleChange={handleChange}
                  formData={formData}
                  isPreviewMode={isPreviewMode} />

              </div>
            }
            {activeStep === 3 &&
              <div>
                <FourthStepFields
                  isMobile
                  handleChange={handleChange}
                  formData={formData}
                  selectedFileName={selectedFileName}
                  setSelectedFileName={setSelectedFileName}
                  isPreviewMode={isPreviewMode}
                  programas={programas}
                  openDlg={openDlg}
                  setOpenDlg={setOpenDlg}
                  handlePreviewFile={handlePreviewFile} />

              </div>
            }
            {activeStep === 4 &&
              <div>
                <FifthStepFields
                  handleChange={handleChange}
                  isMobile
                  formData={formData}
                  estados={estados}
                  isPreviewMode={isPreviewMode} />

              </div>
            }
            <div className='progress-bar'>
              <MobileStepper
                variant="progress"
                steps={5}
                position="static"
                activeStep={activeStep}
                nextButton={
                  <Button size="small" onClick={handleNext} disabled={activeStep === 4 || !validateSteps()}>
                    <KeyboardArrowRight />
                  </Button>
                }
                backButton={
                  <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                    <KeyboardArrowLeft />
                  </Button>
                } />

              <div className='progress-action-row'>
                <div style={{ width: '45%' }}>
                  <CustomButton
                    disabled={creationLoading || editionLoading}
                    onClick={() => navigate(-1)}
                    fullWidth
                    variant={'outlined'}>

                    Cancelar
                  </CustomButton>
                </div>
                <div style={{ width: '45%' }}>
                  <CustomButton
                    onClick={() => handleSubmitForm()}
                    disabled={!validateSteps(formData?.idEstado === ESTADO_A_EXTERNAR) || isPreviewMode}
                    fullWidth
                    isLoading={creationLoading || editionLoading}
                    variant={'contained'}>

                    Guardar
                  </CustomButton>
                </div>
              </div>
            </div>
          </div>
        </MobileContainer>
      }
    </div>);

};

const useGetPacienteProbableFormData = (editPacienteData) => {
  const [delegaciones, setDelegaciones] = useState([]);
  const [instituciones, setInstituciones] = useState([]);
  const [estados, setEstados] = useState([]);
  const [estadosOriginales, setEstadosOriginales] = useState();
  const [formData, setFormData] = useState(initialFormModel);
  const [tipoDocumentoOptions, setTipoDocumentoOptions] = useState([]);
  const [programas, setProgramas] = useState([]);
  const [hayInstituciones, setHayInstituciones] = useState(false);

  const [getDelegaciones, { data: dataDelegaciones, loading: loadingDelegaciones }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegaciones) return;
    const registros = adaptDelegacionArray(dataDelegaciones);
    setDelegaciones(registros.filter((i) => i.id != null)); // descarto Casa Central
    if (registros.length == 1) {
      setFormData({
        ...formData,
        idDelegacion: registros[0].id
      });
    }
  }, [dataDelegaciones]);

  const [getInstituciones, { data: dataInstituciones }] = useLazyQuery(GET_INSTITUCIONES_BY_DELEGACION_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataInstituciones) return;
    setInstituciones(dataInstituciones?.institucionesByDelegacionAndUsuario?.map((i) => ({ displayName: i?.nombre, id: i?.cod_Institucion })) || []);
    setHayInstituciones(dataInstituciones?.institucionesByDelegacionAndUsuario.length > 0);

    if (dataInstituciones?.institucionesByDelegacionAndUsuario.length > 0) {
      setEstados(estadosOriginales);
      if (dataInstituciones?.institucionesByDelegacionAndUsuario.length == 1)
        setFormData({
          ...formData,
          codInstitucion: dataInstituciones?.institucionesByDelegacionAndUsuario[0].cod_Institucion
        });
    } else {
      const estadosFiltrados = estadosOriginales.filter((e) => e.id != ESTADO_OBITO && e.id != ESTADO_RECUPERADO); // óbito - recuperado
      setEstados(estadosFiltrados);
      setFormData({
        ...formData,
        codInstitucion: null
      });
    }
  }, [dataInstituciones]);

  const { data: dataPrograma } = useQuery(GET_PROGRAMA_PRE_PACIENTE);

  useEffect(() => {
    if (!dataPrograma) return;
    setProgramas(adaptProgramaArray(dataPrograma?.allProgramasPrePaciente));
  }, [dataPrograma]);

  const { data: dataEstados } = useQuery(GET_ALL_ESTADOS);

  useEffect(() => {
    if (!dataEstados) return;
    setEstados(dataEstados?.allEstadosPrePaciente?.map((e) => ({ displayName: e.nombre, id: e.id })) || []);
    setEstadosOriginales(dataEstados?.allEstadosPrePaciente?.map((e) => ({ displayName: e.nombre, id: e.id })) || []);
  }, [dataEstados]);

  const { data: dataTipoDocumento } = useQuery(GET_ALL_TIPO_DOCUMENTO);

  useEffect(() => {
    if (!dataTipoDocumento) return;
    setTipoDocumentoOptions(dataTipoDocumento?.allTipoDocumento?.map((td) => ({ displayName: td.descripcion, id: td.idTipoDocumento })) || [])
  }, [dataTipoDocumento]);

  const [getPacienteProbableById, { data: dataPaciente, loading: pacienteLoading }] = useLazyQuery(GET_PACIENTE_PROBABLE_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataPaciente) return;
    if (dataPaciente) {
      const { prePacienteById } = dataPaciente;
      const adaptedObject = {
        idPrePaciente: editPacienteData?.idPaciente,
        idDelegacion: prePacienteById?.idDelegacion,
        codInstitucion: prePacienteById?.codInstitucion,
        nombre: prePacienteById?.nombre,
        apellido: prePacienteById?.apellido,
        sexo: prePacienteById?.sexo,
        edad: prePacienteById?.edad,
        fechaNacimiento: prePacienteById?.fechaNacimiento,
        idTipoDocumento: prePacienteById?.idTipoDocumento,
        nroDocumento: prePacienteById?.nroDocumento,
        telPaciente: prePacienteById?.telPaciente,
        telFamiliar: prePacienteById?.telFamiliar,
        nombreFamiliar: prePacienteById?.nombreFamiliar,
        observacion: prePacienteById?.observacion,
        idEstado: prePacienteById?.idEstado,
        fechaAltaProbable: prePacienteById?.fechaAltaProbable,
        referente: prePacienteById?.referente,
        financiador: prePacienteById?.financiador,
        idTipoModulo: prePacienteById?.idTipoModulo,
        fechaAlta: prePacienteById?.fechaAlta,
        prescripcionPacienteInput: prePacienteById?.idPrescripcionPacienteNavigation?.imagenPerfil != null ? {
          contentType: prePacienteById?.idPrescripcionPacienteNavigation?.contentType,
          titulo: prePacienteById?.idPrescripcionPacienteNavigation?.titulo,
          imagenExtension: prePacienteById?.idPrescripcionPacienteNavigation?.imagenExtension,
          imagenPerfil: prePacienteById?.idPrescripcionPacienteNavigation?.imagenPerfil
        } : {}
      };
      setFormData(adaptedObject);
    }
  }, [dataPaciente]);

  useEffect(() => {
    if (formData?.idDelegacion) {
      getInstituciones({ variables: { idDelegacion: formData?.idDelegacion } });
    }
  }, [formData?.idDelegacion]);

  useEffect(() => {
    const storageId = sessionStorage.getItem('idUsuario');
    if (storageId) {
      const userId = JSON.parse(storageId);
      getDelegaciones({
        variables: {
          idUsuario: userId
        }
      });
    }
    if (editPacienteData?.idPaciente > 0 && !loadingDelegaciones) {
      getPacienteProbableById({
        variables: {
          prepacienteId: editPacienteData?.idPaciente
        }
      });
    }
  }, []);

  return {
    delegaciones,
    hayInstituciones,
    instituciones,
    estados,
    formData,
    setFormData,
    tipoDocumentoOptions,
    programas
  };
};

const FirstStepFields = ({ isMobile, delegaciones, handleChange, formData, instituciones, hayInstituciones, esVentas, isPreviewMode }) => {
  return (
    <>
      <Grid size={{ xs: 1 }}>
        <SelectInput
          onChange={handleChange}
          disabled={isPreviewMode}
          label='Delegación'
          name='idDelegacion'
          options={delegaciones}
          value={formData?.idDelegacion || ''}
          style={isMobile && { marginBottom: 16 }} />
      </Grid>
      <Grid size={{ xs: 1 }}>
        {
          instituciones != null && hayInstituciones && !esVentas &&
          <SelectInput
            onChange={handleChange}
            disabled={isPreviewMode}
            label='Institución'
            name='codInstitucion'
            options={instituciones}
            value={formData?.codInstitucion} />

        }
      </Grid>
      <Grid size={{ xs: 1 }}>
        <TextInput
          onChange={handleChange}
          value={formData?.nombre || ''}
          label='Nombre'
          disabled={isPreviewMode}
          name='nombre'
          margin={isMobile ? 'normal' : undefined} />
      </Grid>
      <Grid size={{ xs: 1 }}>
        <TextInput
          onChange={handleChange}
          disabled={isPreviewMode}
          value={formData?.apellido || ''}
          label='Apellido'
          name='apellido'
          margin={isMobile ? 'normal' : undefined} />
      </Grid>
    </>);
};

const SecondStepFields = ({ isMobile, handleChange, formData, isPreviewMode, tipoDocumentoOptions }) => {
  return (
    <>
      <Grid size={{ xs: 1, lg: 0.6 }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: 15 }}>Tipo de documento</span>
          <ButtonOptionGroup
            disabled={isPreviewMode}
            options={tipoDocumentoOptions}
            selectedOption={formData?.idTipoDocumento}
            name='idTipoDocumento'
            onOptionClick={(index, e) => {
              handleChange({
                target: {
                  value: parseInt(e.target.id, 10),
                  name: e.target.name
                }
              });

            }} />

        </div>
      </Grid>

      <Grid size={{ xs: 1, lg: 0.4 }}>
        <TextInput
          label='Número de documento'
          type={formData?.idTipoDocumento == 1 ? 'number' : ''}
          disabled={isPreviewMode}
          name='nroDocumento'
          value={formData?.nroDocumento || ''}
          onChange={handleChange}
          margin={isMobile ? 'normal' : undefined} />
      </Grid>
      <Grid item xs={1} lg={0.4} sx={{ marginTop: isMobile ? '10px' : '' }}>
        <DateInput
          disabled={isPreviewMode}
          disableFuture
          label={'Fecha de nacimiento'}
          value={formData?.fechaNacimiento || ''}
          onChange={(e) => handleChange({ target: { name: 'fechaNacimiento', value: e != null ? moment(e).format('yyyy-MM-DD') : null } })}
          name='fechaNacimiento'
          margin={isMobile ? 'normal' : undefined} />

      </Grid>
      <Grid size={{ xs: 1, lg: 0.2 }}>
        <TextInput
          label='Edad'
          name='edad'
          disabled={true}
          type='number'
          value={formData?.edad?.toString() || ''}
          onChange={handleChange}
          margin={isMobile ? 'normal' : undefined} />

      </Grid>

      <Grid size={{ xs: 1, lg: 0.2 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: isMobile ? 12 : 0 }}>
          <span style={{ marginRight: 15 }}>Sexo</span>
          <ButtonOptionGroup
            options={OPCIONES_SEXO}
            disabled={isPreviewMode}
            name='sexo'
            selectedOption={OPCIONES_SEXO.indexOf(formData?.sexo)}
            onOptionClick={(index, e) => handleChange({
              target: {
                value: OPCIONES_SEXO[index],
                name: e.target.name
              }
            })} />

        </div>
      </Grid>
    </>);

};


const ThirdStepFields = ({ isMobile, handleChange, formData, isPreviewMode }) => {
  return (
    <>
      <Grid size={{ xs: 1 }}>
        <TextInput
          label='Teléfono del paciente'
          disabled={isPreviewMode}
          name='telPaciente'
          margin={isMobile ? 'normal' : undefined}
          onChange={handleChange}
          value={formData?.telPaciente || ''} />

      </Grid>
      <Grid size={{ xs: 1 }}>
        <TextInput
          label='Financiador'
          disabled={isPreviewMode}
          name='financiador'
          margin={isMobile ? 'normal' : undefined}
          onChange={handleChange}
          value={formData?.financiador} />

      </Grid>
      <Grid size={{ xs: 1 }}>
        <TextInput
          label='Familiar de contacto'
          disabled={isPreviewMode}
          name='nombreFamiliar'
          margin={isMobile ? 'normal' : undefined}
          onChange={handleChange}
          value={formData?.nombreFamiliar || ''} />

      </Grid>
      <Grid size={{ xs: 1 }}>
        <TextInput
          disabled={isPreviewMode}
          margin={isMobile ? 'normal' : undefined}
          name='telFamiliar'
          label='Teléfono del familiar de contacto'
          onChange={handleChange}
          value={formData?.telFamiliar || ''} />

      </Grid>
    </>);

};

const FourthStepFields = ({
  isMobile,
  handleChange,
  formData,
  selectedFileName,
  setSelectedFileName,
  isPreviewMode,
  programas,
  openDlg,
  setOpenDlg,
  handlePreviewFile
}) => {

  return (
    <>
      <Grid size={{ xs: 1 }}>
        <TextInput
          disabled={isPreviewMode}
          margin={isMobile ? 'normal' : undefined}
          name='referente'
          label='Referente'
          onChange={handleChange}
          value={formData?.referente} />

      </Grid>
      <Grid size={{ xs: 2, lg: 1 }}>
        <SelectInput
          label={'Programa'}
          disabled={isPreviewMode}
          name='idTipoModulo'
          options={programas}
          margin={isMobile ? 'dense' : 'none'}
          value={formData?.idTipoModulo}
          onChange={handleChange} />

      </Grid>
      <Grid size={{ xs: 2, lg: 1 }} sx={{ marginTop: isMobile ? '10px' : '' }}>
        <FileInput
          label='Cargar prescripción médica'
          name='prescripcionPaciente'
          maxFileSize={8}
          loadedFileName={
            selectedFileName ||
            formData?.prescripcionPacienteInput?.titulo ||
            formData?.idPrescripcionPacienteNavigation?.titulo
          }
          disabled={isPreviewMode}
          onDeleteImage={() => {
            setSelectedFileName('');
            setOpenDlg(false);
            handleChange({
              target: {
                name: "prescripcionPacienteInput",
                value: null
              }
            });
          }}
          onChange={(rawImageData) => {
            obtenerDataBytesImagen(rawImageData).then((convertedImage) => {
              setSelectedFileName(convertedImage?.nombre);
              handleChange({
                target: {
                  name: "prescripcionPacienteInput",
                  value: {
                    contentType: convertedImage?.contenttype,
                    imagenPerfil: convertedImage?.archivo,
                    imagenExtension: convertedImage?.extension,
                    titulo: convertedImage?.titulo
                  }
                }
              });
            });
          }}
          onClickImagen={handlePreviewFile}
          mobileLayout={isMobile}
          style={{ marginTop: isMobile ? 8 : 0 }} />

        {openDlg && <DocumentViewer data={
          {
            contentType: formData?.prescripcionPacienteInput?.contentType,
            titulo: formData?.prescripcionPacienteInput?.titulo,
            extension: formData?.prescripcionPacienteInput?.imagenExtension,
            archivo: formData?.prescripcionPacienteInput?.imagenPerfil
          }
        } setOpenDlg={setOpenDlg} download={true} />}
      </Grid>
    </>);

};

const FifthStepFields = ({ isMobile, handleChange, formData, estados, isPreviewMode }) => {
  return (
    <>
      <Grid size={{ xs: 2, lg: 4 }}>
        <TextInput
          label='Observaciones'
          multiline
          rows={isMobile ? 3 : 4}
          disabled={isPreviewMode}
          name='observacion'
          onChange={handleChange}
          value={formData?.observacion} />

      </Grid>
      <Grid size={{ xs: 2, lg: 1 }} sx={{ marginTop: isMobile ? '10px' : '' }}>
        <SelectInput
          label={'Estado'}
          disabled={isPreviewMode}
          name='idEstado'
          options={estados}
          margin={isMobile ? 'dense' : 'none'}
          value={formData?.idEstado}
          onChange={handleChange} />

      </Grid>
      <Grid size={{ xs: 1, lg: 0.4 }} sx={{ marginTop: isMobile ? '10px' : '' }}>
        <DateInput
          disabled={isPreviewMode}
          label={'Fecha de alta prob.'}
          value={formData?.fechaAltaProbable}
          onChange={(e) => handleChange({ target: { name: 'fechaAltaProbable', value: e != null ? moment(e).format('yyyy-MM-DD') : null } })}
          name='fechaAltaProbable'
          margin={isMobile ? 'normal' : undefined} />

      </Grid>
    </>);

};

const OPCIONES_SEXO = ['F', 'M'];